
import { IFieldItem, IMetaData, ITEMTYPE, ROWPOSITION } from "src/app/shared/components/field-item/field-item.model";

export interface IAllFieldItems extends IMetaData, IAllQuestion {}

export interface IRowContent {
   content: string;
   send: boolean;
   noData: boolean;
}

export interface IRow {
   send: boolean;
   title:string;
   description: string;
   fieldtype: string; 
   dependson?: string;
   dependstype?: string;
   noData?: string;
   isroworcolumn?: ROWPOSITION;
}

export interface IAllQuestion {
   question_id: string;
   fieldtype: ITEMTYPE;
   sort: number;
   dependsType?: string;
   dependsQuestion?: string;
   dependsOption?: string;
}

export enum ISROWORCOLUMN {
   column = 'column',
   row = 'row'
}

export enum FC_QIR {
   ROW = "row",
   NODATA = "noData"
}

export enum SIZE {
   PERCENT100 = "100%"
}

export enum FIELDWIDTH {
   MIN = "500px",
   MAX = "500px"
}

export type TRow = IRow & IFieldItem;
